import React from 'react';
import { Button, Grid, Text, ThemeUIStyleObject } from 'theme-ui';
type Props = {
  body: Queries.ModalFragmentFragment['body'];
  bodyMobile?: Queries.ModalFragmentFragment['bodyMobile'];
  dismissMessage?: Queries.ModalFragmentFragment['dismissMessage'];
  forwardSx?: ThemeUIStyleObject;
  handleClose: () => void;
};
const ModalBody = ({ body, bodyMobile, forwardSx, handleClose, dismissMessage }: Props) => {
  const sharedStyles = {
    my: [0, '0.4rem'],
    lineHeight: 1.15,
    letterSpacing: '-0.01em',
    '> *:not(:last-child)': { mt: 0, mb: ['1.6rem', '1.16rem'] },
    '> *:last-child': { my: 0, fontSize: '1.2rem' },
    '*:is(ul, ol)': { pl: '4.8 rem' },
    li: { mb: '0.56rem' },
  };

  return (
    <Grid
      sx={{
        ...forwardSx,
        px: '2.4rem',
        gridTemplateColumns: '1fr',
        gridGap: '1.6rem',
        pb: '2.4rem',
      }}
    >
      <Text
        as="p"
        sx={{
          display: [!!bodyMobile ? 'none' : 'block', 'block'],
          fontSize: ['1.4rem', '1.6rem'],
          ...sharedStyles,
        }}
        dangerouslySetInnerHTML={{ __html: body?.childMarkdownRemark?.html ?? '' }}
      />
      <Text
        as="p"
        sx={{
          display: ['block', 'none'],
          fontSize: '1.4rem',
          ...sharedStyles,
        }}
        dangerouslySetInnerHTML={{ __html: bodyMobile?.childMarkdownRemark?.html ?? '' }}
      />
      {dismissMessage ? (
        <Button
          onClick={handleClose}
          variant="bare"
          sx={{
            justifySelf: ['center', 'start'],
            textDecoration: 'underline',
            textTransform: 'uppercase',
            width: 'fit-content',
            lineHeight: 1.15,
            fontWeight: 400,
            fontSize: '1.4rem',
          }}
        >
          {dismissMessage}
        </Button>
      ) : null}
    </Grid>
  );
};

export default ModalBody;
